import React from "react";
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-358" data-mp="vyl6m6i5gx5b">
      <h2 className={`font-serif text-[2rem] font-black leading-[1.12] sm:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-359" data-mp="w17fqakovkpn">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed sm:text-xl ${dark ? "text-brand-100" : "text-ink/70"}`} data-id="element-360" data-mp="n0rel7rf4pny">{subtitle}</p>}
    </div>;
}